<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="inputedValue" scrollable :width="width">
        <v-card class="rounded-lg">
          <v-card-text class="pa-0">
            <v-alert
              color="red"
              outlined
              text
              type="error"
              class="ma-0"
              @click="close"
            >
              {{ $t(text) }}
            </v-alert>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    value: { default: false },
    width: { default: '360px' },
    text: { default: 'common.common_finish-operation' }
  },
  data: () => ({
    displayFlg: false
  }),
  methods: {
    close() {
      this.inputedValue = false
    },
    complete() {
      this.inputedValue = false
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
